import { showMessage } from 'helpers/message';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faTruck, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { Row, Col } from 'reactstrap';
import React, { useEffect, useState } from 'react';

//Api
import transportador_api from '../../api/transportador_api';

//Components
import Loading from '../../components/Loading/Loading';
import MainCard from 'components/MainCard/MainCard';
import TabelaListagemFichas from 'components/TabelaListagemFichas/TabelaListagemFichas';

export default function FichaTransportadorDisponivel({ id, btnVoltar }) {
    //Estado de controle do loading 
    const [loading, setLoading] = useState(false);

    //Estado de controle dos dados do transportador
    const [transportador, setTransportador] = useState({});

    //Carrega os dados do transportador selecionado
    useEffect(() => {
        setLoading(true);
        transportador_api.GetItemDisponivel(id).then(response => {
            setTransportador(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }, []);
    return (
        <MainCard btnVoltar={btnVoltar} >
            {loading && <Loading />}
            <h5 className="bg-primary bg-gradient p-2 rounded-3 d-flex justify-content-between align-items-center" style={{ color: "#fff" }}>
                <span><FontAwesomeIcon icon={faPencilAlt} className="me-2" /> Identificação do transportador</span>
            </h5>
            <div className='text-secondary'>
                <Row>
                    <Col md="12" lg="4">
                        <p><span className="fw-bold">Fantasia: </span>{transportador.fantasia && transportador.fantasia != "" ? transportador.fantasia : "Não informado"}</p>
                    </Col>
                    <Col md="12" lg="4">
                        <p><span className="fw-bold">E-mail: </span>{transportador.email && transportador.email != "" ? transportador.email : "Não informado"}</p>
                    </Col>
                    <Col md="12" lg="4">
                        <p><span className="fw-bold">Responsável: </span>{transportador.responsavel && transportador.responsavel != "" ? transportador.responsavel : "Não informado"}</p>
                    </Col>


                </Row>
                <Row>
                    <Col md="12" lg="4">
                        <p><span className="fw-bold">Fone: </span>{transportador.fone && transportador.fone != "" ? transportador.fone : "Não informado"}</p>
                    </Col>
                    <Col md="12" lg="4">
                        <p><span className="fw-bold">Celular: </span>{transportador.celular && transportador.celular != "" ? transportador.celular : "Não informado"}</p>
                    </Col>
                </Row>
                <h5 className="bg-primary bg-gradient p-2 rounded-3 d-flex justify-content-between align-items-center" style={{ color: "#fff" }}> <span><FontAwesomeIcon icon={faMapMarkerAlt} className="me-2" /> Endereço</span></h5>
                <Row>
                    <Col md="12" lg="4">
                        <p><span className="fw-bold">CEP: </span> {transportador.cep}</p>
                    </Col>
                    <Col md="12" lg="4">
                        <p><span className="fw-bold">Cidade: </span> {transportador.cidade}</p>
                    </Col>
                    <Col md="12" lg="4">
                        <p><span className="fw-bold">UF: </span> {transportador.uf}</p>
                    </Col>
                </Row>
                <Row>
                    <Col md="12" lg="4">
                        <p><span className="fw-bold">Bairro: </span> {transportador.bairro}</p>
                    </Col>
                    <Col md="12" lg="4">
                        <p><span className="fw-bold">Logradouro: </span> {transportador.logradouro}</p>
                    </Col>
                    <Col md="12" lg="4">
                        <p><span className="fw-bold">Número: </span> {transportador.numero}</p>
                    </Col>
                </Row>
                <Row>
                    <Col md="12" lg="12">
                        <p><span className="fw-bold">Complemento: </span> {transportador.complemento}</p>
                    </Col>
                </Row>
            </div>
            <h5 className="bg-primary bg-gradient p-2 rounded-3 d-flex align-items-center justify-content-between" style={{ color: "#fff" }}><span><FontAwesomeIcon icon={faTruck} className="me-2" /> Tipos de coletas que o transportador atende </span></h5>
            <TabelaListagemFichas headers={[{ value: "Tipo de coleta", objectValue: "tipoColeta" }, { value: "Implementos", objectValue: "implementos" }]} items={transportador.tipoColetas} />

        </MainCard>
    )
}
